export const TabNames = {
    YourNotes: 'YourNotes',
    Search: 'Search',
    YourData: 'YourData',
    Library: 'Library',
};
